import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export interface IUpdateSaveCardActionParams {
    saveCard: boolean;
}

export class UpdateSaveCardAction extends BaseAction<void, IUpdateSaveCardActionParams> {
    override async run(): Promise<void | null> {
        try {
            const { saveCard } = this.params!;
            updateRecoilState("saveCardAtom", saveCard);
        } catch (error) {
            console.error("Error in UpdateSaveCardAction:", error);
        }
    }
}

export const updateSaveCardAction = new UpdateSaveCardAction();

